<ng-container *ngIf="!checkIsSearchPage(); else searchPageViewTemplate">
  <div class="header" id="main-content-id" [ngClass]="{'dashboard': isDashboard}">
    <div class="header-wrapper">
      <a class="logo-place she"
        [routerLink]="!isOnlySearchPage ? '' : null"
        >
        <img src="./assets/images/trinity-logo.svg" alt="" class="logo-img">
      </a>

      <div class="menu-group">
        <div class="side-menus">
          <button class="arrow-btn" aria-label="Menu" (click)="openMobileMainMenu('')"><img src="assets/images/hamburger.svg" alt=""></button>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<ng-template #searchPageViewTemplate>
  <div class="header for-search" id="main-content-id" [ngClass]="{'dashboard': isDashboard}">
    <div class="header-wrapper">
      <a class="logo-place"
      [routerLink]="!isOnlySearchPage ? '' : null"
      >
     <img src="{{isMobileView ? './assets/images/trinity-logo.png' : './assets/images/trinity-logo.svg'}}" alt="" class="logo-img">
      </a>
      <div class="menu-group">
        <app-search-box class="s-box" [label]="'city_name'" [viewType]="'mobile'" [showBack]="true"></app-search-box>
      </div>
      <button class="arrow-btn" *ngIf="isMobileView" aria-label="Menu" (click)="openMobileMainMenu('')"><img src="assets/images/hamburger.svg" alt=""></button>
      <div class="side-menus" [ngClass]="{'only-search': checkIsOnlySearchPage()}">
        <button class="arrow-btn" aria-label="Menu" (click)="openMobileMainMenu('')"><img src="assets/images/hamburger.svg" alt=""></button>
      </div>
    </div>
  </div>
</ng-template>
